/*!
 * Link product option selectors
 */ export const getOptionValues = function(variants, optionNames) {
    return optionNames.map(function(_, optionIndex) {
        return variants.map(function(variant) {
            return variant.options[optionIndex];
        }).filter(function ensurePresence(optionValue) {
            return Boolean(optionValue && typeof optionValue === 'string');
        }).filter(function keepUniqueValuesOnly(optionValue, index, self) {
            return self.indexOf(optionValue) === index;
        });
    });
};
export const filterProductOptions = function({ optionNames , variants: allVariants , selectedOptions , ignoreSelectedOptions =false  }) {
    const allOptionValues = getOptionValues(allVariants, optionNames);
    return allOptionValues.map(function(rowOptions, rowIndex) {
        const variants = allVariants.filter((v)=>{
            return selectedOptions.slice(0, rowIndex).every((selectedOption, selectedOptionIndex)=>{
                return v.options[selectedOptionIndex] === selectedOption;
            });
        });
        return rowOptions.map(function(name) {
            const isSelected = selectedOptions[rowIndex] === name;
            if (!ignoreSelectedOptions) {
                if (isSelected) {
                    return {
                        name,
                        status: 'selected'
                    };
                }
            }
            const availableVariants = variants.filter((v)=>{
                return v.options[rowIndex] === name;
            });
            if (availableVariants.length === 0) {
                return {
                    name,
                    status: 'unavailable'
                };
            }
            return {
                name,
                status: availableVariants.some((v)=>v.available) ? 'in-stock' : 'out-of-stock'
            };
        });
    });
};
